import app, { Component } from 'apprun';
import { api } from '../api'; // Adjust path to your api.ts

export default class JsonDisplayBlade extends Component {
  // 1. Initial State
  state = {
    id: '',
    title: 'JSON Viewer',
    urlToCall: '',
    data: null,
    loading: true,
    error: null,
    searchTerm: ''
  };

  // 2. Lifecycle: Runs automatically when the component is attached to the DOM
  mounted = (props: any) => {
    this.run('init', props);
  };

  update = {
    'init': (state: any, props: any) => {
      const newState = { ...state, ...props, ...(props.state), loading: true, error: null };
      this.run('fetch', newState.urlToCall);
      return newState;
    },

    'fetch': async (state: any, url: string) => {
      try {
        const data = await api.invoke('GET',url,null);
        return { ...state, data, loading: false, error: null };
      } catch(error){
        return { ...state, loading: false, error: error.message || 'Unknown error' };
      }
    },

    'refresh': (state: any) => {
      this.run('fetch', state.urlToCall);
      return { ...state, loading: true };
    },

    'update-search': (state: any, e: any) => {
      return { ...state, searchTerm: e.target.value };
    },

    'close-panel': (state: any) => {
      app.run('#clear-panel', state.id);
      return state;
    }
  };

  renderPrettyJson = (state: any) => {
    if (state.data === null || state.data === undefined) { return ''; }

    let jsonString = JSON.stringify(state.data, null, 2);

    // Escape HTML to prevent injection
    jsonString = jsonString.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

    // JSON Syntax highlighting (Regex adds specific classes for CSS)
    jsonString = jsonString.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
      let cls = 'json-number';
      if (/^"/.test(match)) {
        if (/:$/.test(match)) {
          cls = 'json-key';
        } else {
          cls = 'json-string';
        }
      } else if (/true|false/.test(match)) {
        cls = 'json-boolean';
      } else if (/null/.test(match)) {
        cls = 'json-null';
      }
      return `<span class="${cls}">${match}</span>`;
    });

    // Search Highlight
    if (state.searchTerm) {
      const escapedSearchTerm = state.searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const regex = new RegExp(`(${escapedSearchTerm})`, 'gi');
      jsonString = jsonString.replace(/(<span class="json-[^"]+">)(.*?)(<\/span>)/g, function (_, openTag, value, closeTag) {
        return `${openTag}${value.replace(regex, '<mark class="search-highlight">$1</mark>')}${closeTag}`;
      });
    }

    return jsonString;
  };

  handleCopy = (state: any) => {
    const textToCopy = state.error ? state.error : JSON.stringify(state.data, null, 2);
    navigator.clipboard.writeText(textToCopy);
    alert('Copied to clipboard!');
  };

  view = (state: any) => {
    return (
      <div class="json-blade-container">
        {/* Header Controls */}
        <div class="json-blade-header">
          <h3>{state.title}</h3>
          <div class="json-blade-actions">
            <input
              type="text"
              placeholder="Search JSON..."
              value={state.searchTerm}
              oninput={(e) => this.run('update-search', e)}
              class="json-search-input"
            />
            <button onclick={() => this.run('refresh')} title="Refresh Data">
              <i class="fa fa-refresh"></i> Refresh
            </button>
            <button onclick={() => this.handleCopy(state)} title="Copy Raw JSON">
              <i class="fa fa-copy"></i> Copy
            </button>
            <button onclick={() => this.run('close-panel')} title="Close Panel">
              <i class="fa fa-close"></i> Close
            </button>
          </div>
        </div>

        {/* Content Container */}
        <div class="json-blade-content">
          {state.loading ? (
            <div>Loading data...</div>
          ) : (
            <pre class="json-pretty-display">
              {`_html:${this.renderPrettyJson(state)}`}
            </pre>
          )}
        </div>
      </div>
    );
  };
}
